import { z } from 'zod';

/**
 * Os dois envios da pessoa numa edição:
 *
 * - `ensaio` — antes da prova, as questões do mapper. Respostas por
 *   **`questionId`**: o número da tela é só a posição no ensaio.
 * - `gabarito` — depois da prova, o que ela marcou na prova oficial. Respostas
 *   por **número da questão**, que é o que a folha da prova tem.
 *
 * Os dois têm a mesma forma e o mesmo ciclo (enviar uma vez, ler depois), por
 * isso dividem o módulo.
 */
export type SubmissionKind = 'ensaio' | 'gabarito';

/** Chave (questionId ou número, em texto) → índice 0-based da alternativa. */
export const SubmissionAnswersSchema = z
  .record(z.string(), z.number().int().min(0))
  .refine((answers) => Object.keys(answers).length > 0, {
    message: 'Responda ao menos uma questão para enviar',
  });

export const SubmissionRequestSchema = z.object({
  exam: z.string().min(1),
  edition: z.number().int().positive(),
  answers: SubmissionAnswersSchema,
});

export const SubmissionSchema = z.object({
  answers: z.record(z.string(), z.number().int().min(0)),
  submittedAt: z.string(),
});

export type SubmissionRequest = z.infer<typeof SubmissionRequestSchema>;
export type Submission = z.infer<typeof SubmissionSchema>;
